import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from "react-dom";
import {Route, Router } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import history from './history';
import './index.css';
import './component/css/App.scss';
import TranslateService from './services/TranslateService';
import './component/css/Colors.scss';
import 'react-datepicker/dist/react-datepicker.css';
import App from './App';
import { setStyle } from './services/Style';

const sentryMeta = document.querySelector('meta[name="nalgoo:sentry"]');
if (sentryMeta && sentryMeta.getAttribute('content')) {
	const dsn = sentryMeta.getAttribute('content');

	Sentry.init({
		dsn,
		integrations: [new BrowserTracing()],
		tracesSampleRate: 0.2,
		denyUrls: [
			/googletagmanager\.com\/gtm\.js/i,
		],
	});
}

window.Translator = new TranslateService();
window.sessionStorage.setItem("referrer", document.referrer.split("https://").join('').split("http://").join('').split('/')[0]);
let customerName =  window.location.pathname.substring(window.location.pathname.indexOf('gate/')+5);
if (customerName.includes('/')) {
	customerName = customerName.substring(0, customerName.indexOf('/'));
}
const urlParams = new URLSearchParams(window.location.search);
if (urlParams.has('refId')) {
	sessionStorage.setItem(customerName+'-refId', urlParams.get('refId'));
}

Promise.all([window.Translator.loadTranslates(), setStyle(customerName) ]).then(() => {
    const routing = (
        <Router history={history}>
            <Route path="/" component={App} />
        </Router>
    );

    ReactDOM.render(routing, document.getElementById("groot"));
});


